import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

export interface PlanCardProps {
  name: string;
  price: string;
  priceId?: string;
  features: string[];
  onSubscribe: (plan: string) => void;
}

export const PlanCard = ({ name, price, priceId, features, onSubscribe }: PlanCardProps) => {
  return (
    <Card className="p-6 flex flex-col">
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold">{name}</h3>
        <div className="mt-2">
          <span className="text-3xl font-bold">{price}</span>
          <span className="text-muted-foreground">/month</span>
        </div>
      </div>
      <ul className="space-y-3 mb-6 flex-grow">
        {features.map((feature) => (
          <li key={feature} className="flex items-start gap-2">
            <Check className="w-4 w-4 text-primary mt-1 flex-shrink-0" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <Button 
        className="w-full mt-auto" 
        onClick={() => onSubscribe(name)}
      >
        Subscribe Now
      </Button>
    </Card>
  );
};